import { CommonModule } from '@angular/common'
import { NgModule } from '@angular/core'
import { I18nModule, provideConfig } from '@spartacus/core'
import { DIALOG_TYPE, IconModule, LayoutConfig } from '@spartacus/storefront'
import { EbFavoritesCreateDialogComponent } from '../../features/favorites/components/favorites-create-dialog/eb-favorites-create-dialog.component'
import { EbGroupedFavoritesComponent } from './eb-grouped-favorites.component'

export const defaultFavoritesDialogModalLayoutConfig: LayoutConfig = {
  launch: {
    ADDED_PRODUCT_FAVORITE: {
      inlineRoot: true,
      component: EbFavoritesCreateDialogComponent,
      dialogType: DIALOG_TYPE.DIALOG
    }
  }
}

@NgModule({
  exports: [EbGroupedFavoritesComponent],
  imports: [I18nModule, IconModule, CommonModule, EbGroupedFavoritesComponent],
  providers: [provideConfig(defaultFavoritesDialogModalLayoutConfig)]
})
export class EbGroupedFavoritesModule {}
